import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
`;

export const Count = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
  font-size: 12px;
  line-height: 1;
  span {
    display: block;
    color: #aab2b8;
  }
  b {
    font-weight: 600;
    font-family: 'IBM Plex Mono', monospace;
    font-variant-numeric: tabular-nums slashed-zero;
    color: ${(props) => props.$color || '#e6eaec'};
  }
`;
